import { type DimensionOptions, StringsWithDataEnumDimension } from '@orus.eu/dimensions'
// Lives in this leaf package: the floor's cross-product UI element types are structural, so nothing central imports this dimension.
import { type MrpwWakamActivityName, mrpwWakamActivityNames } from '@orus.eu/pricing'

const mrpwActivitiesLabelsSet = new Set<string>(mrpwWakamActivityNames)
export function isWakamActivityName(activityLabel: string): activityLabel is MrpwWakamActivityName {
  return mrpwActivitiesLabelsSet.has(activityLabel)
}

export class MrpwWakamActivityDimension<NAME extends string> extends StringsWithDataEnumDimension<
  NAME,
  { label: string },
  ReadonlyArray<readonly [MrpwWakamActivityName, { label: string }]>
> {
  constructor(options: DimensionOptions<NAME, MrpwWakamActivityName>) {
    super({
      ...options,
      entries: mrpwWakamActivityNames.map((name) => [name, { label: getWakamActivityNameLabel(name) }] as const),
    })
  }
}

function getWakamActivityNameLabel(name: MrpwWakamActivityName): string {
  return name === 'NULL' ? '-- Aucune --' : name
}

export const mrpwWakamMainActivityDimension = new MrpwWakamActivityDimension({
  name: 'mrpwWakamMainActivity',
  displayKeys: { name: 'dimension_name_mrpw_wakam_main_activity' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
